module.exports = require("github:angular-ui/ui-router@0.2.15/angular-ui-router");